/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { connect, useDispatch } from 'react-redux';
import momentTZ from 'moment-timezone';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';

import { setTimezone } from 'store/actions/time/timezone';
import UserSessionDataHandler from 'auth/UserSessionsDataHandler';
import { formStyles } from 'consts/styles/Form';
import { userStyles } from 'consts/styles/User';

const DefaultTimeZone = props => {
  const { language, timezone } = props;
  const dispatch = useDispatch();

  const formClasses = formStyles();
  const classesUser = userStyles();

  const [chosenTimezone, setChosenTimezone] = React.useState(timezone);
  const timeZonesList = momentTZ.tz.names();
  React.useEffect(() => {
    UserSessionDataHandler.saveToUserSettingsObjectInStorage(
      UserSessionDataHandler.defaultTimezone,
      chosenTimezone
    );
    dispatch(setTimezone(chosenTimezone));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chosenTimezone]);

  return (
    <>
      <Autocomplete
        id="combo-box-demo"
        options={timeZonesList}
        defaultValue={timezone}
        value={timezone}
        getOptionLabel={option => option}
        onChange={(event, value) => {
          setChosenTimezone(value);
        }}
        className={`${classesUser.User}__wrapper__content__form-container__form`}
        classes={{
          inputRoot: `${formClasses.Form}__select`,
          tag: `${formClasses.Form}__text-field`,
          popupIndicator: `${formClasses.Form}__text-field`,
          clearIndicator: `${formClasses.Form}__text-field`,
          input: `${formClasses.Form}__text-field`,
          listbox: `${formClasses.Form}__select__menu--background-color`,
          popper: `${formClasses.Form}__select__menu__item`,
        }}
        renderInput={params => (
          <TextField
            {...params}
            label={language.defaultTimeZone.header_}
            variant="standard"
            InputLabelProps={{
              classes: {
                root: `${formClasses.Form}__label`,
                focused: `${formClasses.Form}__label`,
              },
            }}
          />
        )}
      />
    </>
  );
};

DefaultTimeZone.propTypes = {
  timezone: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.oneOf([PropTypes.instanceOf(null)]).isRequired,
  ]),
  language: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  timezone: state.timezone,
  language: state.language,
});

export default connect(mapStateToProps)(DefaultTimeZone);
